import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';

import LeadView from 'components/layout/lead/LeadView';

class LeadSlideoutDetails extends React.Component {
  close = e => {
    e.preventDefault();

    const { close } = this.props;
    close();
  };

  render() {
    const {
      intl: { messages },
      appIntl: { urlPrefix },
      type,
      open,
      lead,
    } = this.props;

    return (
      <div id="lead-quickview" className={'quickview-wrapper ' + (open ? 'open ' : '')} key={lead.id}>
        <div className="p-t-10 p-b-10 p-l-20 p-r-20 bg-master">
          <Link to={urlPrefix + 'account/' + type + 's/' + lead.id} className="text-white">
            {lead.title}
          </Link>
          <Link
            to={urlPrefix + 'account/' + type + 's/' + lead.id}
            className="m-l-15 btn-rounded btn btn-xs btn-default p-l-10 p-r-10"
          >
            {messages.details} <i className="fal fa-chevron-right m-l-10" />
          </Link>
          <a href="#close" className="close btn-link quickview-toggle pull-right text-white" onClick={this.close}>
            <span>×</span>
          </a>
        </div>
        <div className="tab-content" style={{ height: '100%' }}>
          <ScrollArea
            speed={0.8}
            className="scroll-wrapper"
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '100%' }}
          >
            {open && <LeadView leadId={lead.id} inModal />}
          </ScrollArea>
        </div>
      </div>
    );
  }
}
LeadSlideoutDetails.defaultProps = {
  open: false,
  lead: {},
  close: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};
export default injectIntl(connect(mapStateToProps)(LeadSlideoutDetails));
